import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Chanhassen",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of Chanhassen Minnesota suburb cityscape with Carver County landscape, Lake Ann and Lake Susan shoreline with residential neighborhoods, tree-lined streets, southwest Twin Cities metro suburban community near Eden Prairie, late afternoon golden hour lighting, professional real estate aerial photography, no readable text or signs",
  heroImageSeq: "chanhassen-mn-hero-2026",
  heroDescription:
    "Heading to a Caribbean resort and your passport just expired? Business trip to Germany with two weeks notice? Family vacation to Europe? We help Chanhassen residents — from Carver County families and Paisley Park-area professionals to Lake Susan and Lake Ann community members — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and third-party resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "44.8608; -93.5308",
  geoPlacename: "Chanhassen, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/chanhassen/",
  localAreaTitle: "Serving Chanhassen & Southwest Carver County",
  localAreaText: [
    "Chanhassen, Minnesota is a premier southwest metro suburb located in Carver County, widely recognized as one of the best places to live in the Twin Cities region. The city is home to Paisley Park Studios — the legendary recording complex built by Prince — which draws musicians, music industry professionals, and tourists from around the world. This international connection makes Chanhassen a community deeply familiar with international travel.",
    "The city sits at the intersection of several major roadways, including US Highway 212 and State Highway 101, providing excellent access to both Eden Prairie, Shakopee, and Chaska. Chanhassen's commercial corridor includes high-performing retail, restaurants, and corporate offices that attract professionals who often travel internationally for business.",
    "Chanhassen's lakefront neighborhoods along Lake Ann, Lake Susan, Lake Lucy, and Rice Marsh Lake create a desirable residential environment for upper-income families. Many residents are executives, medical professionals, and technology workers at nearby companies who travel frequently for business and choose international destinations for family vacations.",
    "The city's excellent school system, Chanhassen High School and Minnetonka School District partnerships, creates a community where families plan international travel for educational enrichment, cultural experiences, and sports competitions. Youth travel sports are particularly active in Chanhassen, with teams traveling to tournaments throughout the year.",
  ],
  nearbyCities: [
    { name: "Chanhassen", zips: "55317" },
    { name: "Eden Prairie", zips: "55346, 55347" },
    { name: "Chaska", zips: "55318" },
    { name: "Shakopee", zips: "55379" },
    { name: "Minnetonka", zips: "55305, 55345" },
    { name: "Victoria", zips: "55386" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required to begin. Complete your order from your lake home or office in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping from Chanhassen to send your documents directly to us.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Chanhassen & Southwest Metro Coverage",
  serviceAreaDescription: "Serving Carver County and southwest metro communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Chanhassen, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office in Chanhassen can take 2–6 months — not viable for upcoming trips or business travel.",
    },
    {
      q: "Can Chanhassen families get passports before a summer vacation?",
      a: "Absolutely. Chanhassen families are a large portion of our Minnesota client base. Many families book summer vacations and discover passport issues close to departure. We regularly process expedited renewals and child passports for families on compressed timelines — as fast as 2–9 business days.",
    },
    {
      q: "What if I have a business trip scheduled to Europe?",
      a: "Chanhassen professionals frequently receive international assignments with 2–3 weeks notice. If your passport is expiring or expired, we can expedite your renewal so you do not miss critical meetings or conference presentations.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center?",
      a: "No — most Chanhassen travelers start online and ship their documents via overnight courier. There is no Fast Passport Center office in Chanhassen. Start your order online, follow our personalized checklist, and ship your documents overnight from any shipping location in the southwest metro.",
    },
    {
      q: "What documents do I need for an expedited passport?",
      a: "Most applicants need: proof of U.S. citizenship, a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order — so you know exactly what is required for your specific situation.",
    },
    {
      q: "Are there passport acceptance facilities near Chanhassen?",
      a: "Yes — Chanhassen and the surrounding southwest metro have several post offices that accept passport applications. First-time applicants and minors must visit an acceptance clerk in person. We can guide you through this step as part of your order.",
    },
  ],
  testimonials: [
    {
      name: "David H.",
      location: "Chanhassen, MN",
      rating: 5,
      text: "I'm in technology and got an invitation to a product launch in London with twelve days notice. My passport had expired six months earlier and I hadn't noticed. Fast Passport Center processed my renewal in four business days. I made the event and it was worth every minute. Highly professional service.",
      service: "Passport Renewal",
    },
    {
      name: "The Peterson Family",
      location: "Chanhassen, MN",
      rating: 5,
      text: "We live near Lake Ann and planned a family trip to Cancun. Our son's child passport had expired and we didn't notice until two weeks before departure. Fast Passport Center processed his renewal in five business days. We made the trip and had an incredible time. Thank you for the fast and professional service.",
      service: "Child Passport",
    },
    {
      name: "Karen M.",
      location: "Chanhassen, MN",
      rating: 5,
      text: "We planned a surprise trip to Paris for our anniversary. My passport had five months left and the airline said that wasn't enough for France. Fast Passport Center processed my renewal in six business days. We went to Paris and it was everything we dreamed of. Thank you for saving our trip.",
      service: "Emergency Renewal",
    },
  ],
  nearbyLinks: [
    { name: "Eden Prairie", href: "/cities/eden-prairie" },
    { name: "Shakopee", href: "/cities/shakopee" },
    { name: "Minnetonka", href: "/cities/minnetonka" },
    { name: "Bloomington", href: "/cities/bloomington" },
    { name: "Burnsville", href: "/cities/burnsville" },
    { name: "Minneapolis", href: "/cities/minneapolis" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Chanhassen",
  introDescription: "Fast, reliable passport processing for Chanhassen and southwest metro Carver County travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Chanhassen and southwest metro resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Chanhassen Post Office",
      address: "7901 Great Plains Blvd, Chanhassen, MN 55317",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(952) 934-9250",
      notes: "Primary passport acceptance facility for Chanhassen residents. Appointment required. Photo services may be available — call ahead.",
    },
    {
      name: "Eden Prairie Post Office",
      address: "8080 Mitchell Rd, Eden Prairie, MN 55344",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(952) 937-6420",
      notes: "Eden Prairie passport acceptance. Full services including photos. Call ahead for appointment.",
    },
    {
      name: "Chaska Post Office",
      address: "411 Walnut St, Chaska, MN 55318",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(952) 448-3740",
      notes: "Serves Chaska and southern Carver County residents. Appointment recommended.",
    },
    {
      name: "Shakopee Post Office",
      address: "1155 1st Ave W, Shakopee, MN 55379",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(952) 445-0760",
      notes: "Scott County coverage. Full passport services with photo capability.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Chanhassen", address: "551 W 78th St, Chanhassen, MN 55317", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Eden Prairie", address: "12701 Technology Dr, Eden Prairie, MN 55344", hours: "Call for hours" },
    { name: "CVS Pharmacy — Eden Prairie", address: "8080 Glen Lane, Eden Prairie, MN 55344", hours: "Daily 7 AM – 10 PM" },
    { name: "The UPS Store — Eden Prairie", address: "12540 Flynn Trail, Eden Prairie, MN 55347", hours: "Call for hours" },
    { name: "FedEx Office — Minnetonka", address: "Minnetonka area", hours: "Call for hours" },
    { name: "Walgreens — Chaska", address: "1 Pioneer Trail, Chaska, MN 55318", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Carver County Driver & Vehicle Services",
      address: "600 E 4th St, Chaska, MN 55318",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Carver County DVS. Driver licenses, REAL ID, titles & registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Scott County Driver & Vehicle Services",
      address: "301 S Fuller St, Shakopee, MN 55379",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Scott County DVS. Online scheduling available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 18 miles from Chanhassen — 20–25 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary international airport for Chanhassen residents. Direct flights to Europe, Asia, and Latin America. Access via Highway 212 to I-494.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
  ],
  travelCards: [
    {
      title: "Southwest Metro Access to MSP",
      subtitle: "Convenient direct access to international flights",
      content:
        "Chanhassen's location provides excellent Highway 212 and I-494 access to MSP Airport. With direct international flights to Amsterdam, London, Paris, Reykjavik, and Tokyo, many southwest metro residents travel nonstop to international destinations.",
      tip: "Check passport expiration before booking MSP international flights. Most countries require 6 months validity beyond your return date.",
      icon: "ri-flight-takeoff-line",
    },
    {
      title: "Paisley Park Community",
      subtitle: "International music professionals and visitors in the area",
      content:
        "Chanhassen's identity is closely tied to Paisley Park Studios. Music industry professionals, artists, and international visitors regularly come through the area. Many local creative professionals have international business connections and travel frequently.",
      tip: "Music and creative industry travel is often booked 2–4 weeks out. Keep your passport current at all times.",
      icon: "ri-music-2-line",
    },
    {
      title: "Lake Community Family Travel",
      subtitle: "Active families planning international vacations",
      content:
        "Chanhassen's lakefront neighborhoods are home to many upper-income families who plan international vacations regularly. Caribbean cruises, European river tours, and resort destinations in Mexico are common choices. These families often book trips 4–6 weeks out.",
      tip: "Book passport renewals at least 8 weeks before any international trip. Children's passports expire in 5 years — check every year.",
      icon: "ri-parent-line",
    },
    {
      title: "Tech & Corporate Travel",
      subtitle: "Corporate professionals with international assignments",
      content:
        "Chanhassen and the southwest metro corridor is home to many technology and corporate professionals who receive international travel assignments with short notice. These assignments are often time-sensitive and non-negotiable.",
      tip: "Corporate travelers should maintain passport validity at all times. Keep 12+ months validity as a professional standard.",
      icon: "ri-briefcase-4-line",
    },
  ],
  destinations: [
    {
      name: "Mexico",
      context: "Cancun, Riviera Maya, and Los Cabos for Chanhassen family resort travel",
      urgency: "Resort packages and spring break trips are often booked 2–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Caribbean",
      context: "Cruises out of Miami and Fort Lauderdale, popular with Chanhassen families",
      urgency: "Cruise departures have fixed dates — passports must be ready on time",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "London and Edinburgh for business and music industry travel",
      urgency: "Business and music industry schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "France",
      context: "Paris for anniversary trips and cultural travel from Chanhassen",
      urgency: "France requires 90 days validity beyond intended stay — check before booking",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Iceland",
      context: "Reykjavik for outdoor adventure travel, popular with MSP nonstop service",
      urgency: "MSP offers nonstop to Iceland — check passport before booking",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Berlin and Munich for corporate travel and business conferences",
      urgency: "Conference schedules are fixed — expedited processing is often the only option",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    { stat: "42%", label: "of Chanhassen expedited requests are family vacation travel discovered within 3 weeks of departure" },
    { stat: "2–3 Weeks", label: "average notice Chanhassen corporate travelers have before an international assignment" },
    { stat: "May–Aug", label: "peak season when school vacation, summer travel, and lake community activity coincide" },
    { stat: "4 Days", label: "fastest renewal turnaround for a Chanhassen technology professional in our records" },
  ],
};

export default function ChanhassenPage() {
  return <CityPage data={data} />;
}